"use client";

import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import React, { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";
import SecondaryButton from "../utils/button/SecondaryButton";
import { SingleWaveDropVote } from "../waves/drop/SingleWaveDropVote";
import ModalLayout from "../waves/memes/submission/layout/ModalLayout";
interface VotingModalProps {
  readonly drop: ExtendedDrop;
  readonly isOpen: boolean;
  readonly onClose: () => void;
}
const VotingModal: React.FC<VotingModalProps> = t0 => {
  const $ = _c(22);
  const {
    drop,
    isOpen,
    onClose
  } = t0;
  const titleId = useId();
  const modalRef = useRef(null);
  const previousActiveElement = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isOpen || $[1] !== onClose) {
    t1 = () => {
      if (!isOpen) {
        return;
      }
      previousActiveElement.current = document.activeElement as HTMLElement;
      modalRef.current?.focus();
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      const handleKeyDown = e => {
        if (e.key === "Escape") {
          onClose();
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.body.style.overflow = originalOverflow;
        document.removeEventListener("keydown", handleKeyDown);
        previousActiveElement.current?.focus();
      };
    };
    t2 = [isOpen, onClose];
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!isOpen) {
    return null;
  }
  let t3;
  if ($[4] !== onClose) {
    t3 = <div className="tw-fixed tw-inset-0" onClick={onClose} aria-hidden="true" />;
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== drop || $[7] !== onClose) {
    t4 = <SingleWaveDropVote drop={drop} onVoteSuccess={onClose} />;
    $[6] = drop;
    $[7] = onClose;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onClose) {
    t5 = <div className="tw-mt-4 tw-flex tw-justify-end"><SecondaryButton onClicked={onClose}>Cancel</SecondaryButton></div>;
    $[9] = onClose;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="tw-pb-6 tw-pt-1">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== onClose || $[15] !== t6 || $[16] !== titleId) {
    t7 = <div className="tw-w-full tw-max-w-2xl tw-z-10 tw-px-4" onClick={_temp2}><ModalLayout title="Vote for this artwork" onCancel={onClose} titleId={titleId}>{t6}</ModalLayout></div>;
    $[14] = onClose;
    $[15] = t6;
    $[16] = titleId;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t3 || $[19] !== t7 || $[20] !== titleId) {
    const modalContent = <div ref={modalRef} role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1} className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px] tw-z-50 tw-flex tw-items-center tw-justify-center tw-outline-none" onClick={_temp}>{t3}{t7}</div>;
    t8 = createPortal(modalContent, document.body);
    $[18] = t3;
    $[19] = t7;
    $[20] = titleId;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default VotingModal;
function _temp(e_0) {
  return e_0.stopPropagation();
}
function _temp2(e_1) {
  return e_1.stopPropagation();
}